import { ENV_VAR, TIMESTAMP } from './constants';
import { _warn } from './helpers';
var storedHeaders = {};
const isMorpheus = process.env.IDP === ENV_VAR.MORPHEUS;

export function getUiModDetails(url) {
	const urlValue = getModUrlValue(url);
	const {manifest} = window.ss.env;
	// default details to return if our lookup fails for any reason
	const details = {
		isValid: false,
		isUniversal: false,
		bootstrapName: null,
		productId: null,
		urlValue,
	};

	// no module is defined
	if (urlValue == null || manifest == null) { return details; }
	if (urlValue.length === 0) { return details; }

	// calculate universal module name (so we can get for it)
	const productId = urlValue.split('-')[0];
	const universalModName = urlValue.replace(productId, 'universal');

	// manifest entries for module and universal module variant
	const modMani = manifest[urlValue];
	const uniMani = manifest[universalModName];

	// check for exact match as well as universal module
	const isUniversal = uniMani != null;
	const isValid = modMani != null || uniMani != null;

	Object.assign(details, {
		bootstrapName: (isUniversal ? universalModName : urlValue),
		isValid, isUniversal, productId
	});

	return details;
};

export function getTimestamp() {
	return TIMESTAMP;
}

// This function is used to get the module name from the url
export function getModUrlValue(url = window.location.href) {
	const loc = window.document.createElement('a');
	loc.setAttribute('href', url);
	let routePath = loc.pathname;
	if (process.env.IDP === ENV_VAR.MORPHEUS) {
		const routePaths = loc.pathname.split('/');
		// if we are in morpheus, we need to get the app base url and check if it has an app or service in the path
		// then we need to get the third path in the url otherwise we just need the first path
		//Similar logic is written in Supersuit-AngularJsFramework
		routePath = routePaths.length >= 3 && routePaths[3] && (routePaths[1] === 'app' || routePaths[1] === 'service') ? routePaths[3] : routePaths[1];
		return routePath;
	}
	var match = routePath.match(/^\/?([\w-]*)/i);
	if (match != null && match.length === 2) {
		return match[1];
	} else {
		return '';
	}
}

// This function is used to get the app shortname from the url
export function getAppShortName(url) {
	const { hostname, pathname } = url;
	if (!isMorpheus) {
		const firstSegment = pathname.split('/').filter(Boolean)[0] || '';
		return firstSegment.split('-')[0];
	}
	return hostname.split('.')[1].includes('k12') ? hostname.split('.')[0] : pathname.split('/')[1];
}

function fetchHeaders() {
	return new Promise((resolve, reject) => {
		if (Object.keys(storedHeaders).length > 0) {
			resolve(storedHeaders);
			return;
		}
		var req = new XMLHttpRequest();
		req.open('GET', window.location, true);
		req.onload = function () {
			if (req.status >= 200 && req.status < 300) {
				var headersString = req.getAllResponseHeaders();
				var headersArray = headersString.trim().split(/[\r\n]+/);
				var headers = {};
				headersArray.forEach(function (line) {
					var parts = line.split(': ');
					var header = parts.shift();
					var value = parts.join(': ');
					headers[header.toLowerCase()] = value;
				});
				storedHeaders = headers;
				sessionStorage.setItem(
					'isMorpheusLite',
					headers['authorization'] ? true : false
				);
				resolve(headers);
			} else {
				reject('Request failed with status: ' + req.status);
			}
		};
		req.onerror = function () {
			reject('Request error');
		};
		req.send(null);
	});
}

export function getResponseHeader() {
	return new Promise((resolve, reject) => {
		fetchHeaders()
			.then((fetchedHeaders) => {
				const obj  = {
					headers: fetchedHeaders,
					isMorpheusLite: sessionStorage.getItem('isMorpheusLite') === 'true'
				};
				resolve(obj);
			})
			.catch(reject);
	});
}

// This function initializes platform notifications by checking if they are enabled in the app configuration
export const checkForPlatformNotifications = async () => {
	if (isMorpheus) {
		try {
			const appConfigResponse = await fetch(`${process.env.BASE_URL}/app-configs/morpheus-${getAppShortName(window.location)}.json`);
			const appConfigData = await appConfigResponse.json();
			const { notificationConfig: { usePlatformNotifications }, notificationConfig } = appConfigData;
			if (usePlatformNotifications) {
				return {
					...notificationConfig,
					notificationBaseUrl:
						window.buildConfig.endpoint[
							`${getAppShortName(window.location)}`
						].notifications || '',
				};
			}
		} catch (error) {
			_warn('Setting default notification config');
		}
	}
	return {
		usePlatformNotifications: false,
		pollingIntervalInSeconds: 60000
	};
};
